import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router"

import { Button } from "components/Button"
import { Card } from "components/Card/Card"
import { Modal } from "components/Modal/Modal"
import { Information } from "components/Title/Title"
import { ModalDocument } from "client/documents/utils"
import { cdn } from "core/cdn"
import { PROFILE_PAGE } from "core/constants"
import { logout } from "containers/Login/services/actions"
import paymentActions from "containers/Payment/services/actions"
import surveyActions from "containers/Survey/services/actions"
import { useLanguage } from "locales"
import { Call } from "types/payload"
import { PaymentStore, SurveyStore } from "types/store"

export default function PharmacistEnd() {
  const { languages } = useLanguage()
  const dispatch = useDispatch()
  const [sending, setSending] = useState<boolean>(false)
  const [sent, setSent] = useState<boolean>(false)
  const [chosenCall, setChosenCall] = useState<Call | undefined>()
  const [disconnectModalVisible, setDisconnectModalVisible] = useState<boolean>(false)

  const answers = useSelector(({ survey }: { survey: SurveyStore }) => survey.answers)
  const questions = useSelector(({ survey }: { survey: SurveyStore }) => survey.questions)
  const success = useSelector(({ payment }: { payment: PaymentStore }) => payment.success)
  const message = useSelector(({ payment }: { payment: PaymentStore }) => payment.message)
  const call = useSelector(({ payment }: { payment: PaymentStore }) => payment.call)

  useEffect(() => {
    if (answers?.length > 0) {
      dispatch(paymentActions.reset())
      setSending(true)
      dispatch(paymentActions.submit(answers, questions))
      return
    }
    if (call) {
      setSent(true)
      return
    }

    return () => {
      dispatch(surveyActions.reset())
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (success) {
      dispatch(surveyActions.reset())
      setSending(false)
      setSent(true)
    } else if (message) {
      setSending(false)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success, message])

  const handleLogout = () => {
    dispatch(logout())
  }

  return (
    <>
      <Card
        title={languages.pharmacistEndTitle}
        titleSize="medium"
        imgUrl={cdn("/images/tlc_terminee_illustration_blue.svg")}
      >
        <div style={{ width: "90%", margin: "0 auto" }}>
          <p style={{ fontSize: 48, fontWeight: 700, color: "#211452", textAlign: "center", margin: 0 }}>
            {languages.pharmacistEndPrintInfo_html}
          </p>
          <div style={{ width: "100%", display: "flex", justifyContent: "center", paddingTop: 50 }}>
            <Button
              onClick={() => call && setChosenCall(call)}
              type="primary"
              loading={sending}
              disabled={sending || !sent}
              style={{ width: "auto" }}
            >
              {languages.printDocument}
            </Button>
          </div>
        </div>
      </Card>
      <ModalDocument
        call={chosenCall}
        hideSendButton
        onCancel={handleLogout}
        onAccept={() => {
          setChosenCall(undefined)
          setDisconnectModalVisible(true)
        }}
        acceptButtonProps={{ danger: true }}
        acceptText={languages.logout}
      />
      <Modal
        visible={disconnectModalVisible}
        title={languages.beSureToBeDisconnected}
        onCancel={() => {
          setDisconnectModalVisible(false)
          setChosenCall(call)
        }}
        cancelButtonProps={{ type: "primary" }}
        cancelText={languages.rePrint}
        acceptButtonProps={{ danger: true, type: "primary" }}
        acceptText={languages.finishAndDisconnect}
        onAccept={handleLogout}
      >
        <Information text={languages.beSureDocumentsArePrinted} />
      </Modal>
    </>
  )
}
